export interface AdminRoleAttributes {
  id: number;
  role: string;
}

export enum AdminRoleEnum {
  admin = "admin",
  validator = "validator",
  raffle_manager = "raffle_manager",
}
